'use client';

import { useState } from 'react';
import { Cake, ArrowRight } from '@phosphor-icons/react';
import { BirthdayModal } from '@/components/promotions/birthday-modal';

interface ActionsBirthdayProps {
  /**
   * Условия акции с сервера. Не передали — модалка покажет свой зашитый
   * текст. Баннер показывается только когда акция «День рождения» включена
   * в админке (см. app/actions/page.tsx).
   */
  terms?: readonly string[];
}

export function ActionsBirthday({ terms }: ActionsBirthdayProps = {}) {
  const [open, setOpen] = useState(false);

  return (
    <section className="py-0 sm:py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className="relative rounded-3xl overflow-hidden cursor-pointer animate-fade-up group"
          onClick={() => setOpen(true)}
        >
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[var(--primary)] via-[var(--violet-600)] to-[var(--violet-700)]" />

          {/* Decorative circles */}
          <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-white/10" />
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-white/8" />

          {/* Content */}
          <div className="relative z-10 px-8 py-10 sm:px-14 sm:py-14 flex items-center justify-between gap-6">
            <div className="flex-1">
              <div className="w-14 h-14 rounded-2xl bg-white/20 border-2 border-white/30 flex items-center justify-center mb-5">
                <Cake weight="fill" className="w-7 h-7 text-[var(--text-on-primary)]" />
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-black text-[var(--text-on-primary)] mb-3 tracking-tight">
                У Вас день рождения?
              </h2>
              <p className="text-[var(--text-on-primary)]/90 text-base sm:text-lg max-w-lg leading-relaxed">
                Укажите промокод «ДР» и получите ролл в подарок к заказу от 1500₽
              </p>
            </div>
            <div className="hidden sm:flex w-12 h-12 rounded-full bg-white/20 items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110">
              <ArrowRight weight="bold" className="w-6 h-6 text-[var(--text-on-primary)]" />
            </div>
          </div>
        </div>
      </div>

      <BirthdayModal open={open} onClose={() => setOpen(false)} terms={terms} />
    </section>
  );
}
